export default "__VITE_ASSET__BHaCd4G3__"